define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var limitsConfig = require('portlets/responsible-gaming/limits/limits.config');

    module.exports = function() {
        var config = limitsConfig();

        _.extend(config.defaultData, {
            daylosslimit: 5000,
            weeklosslimit: 5000,
            monthlosslimit: 20000
        });

        return config;
    };
});
